import { IBulkUploadCard } from '../../../types/bulkUpload';

export const BULK_UPLOAD_CARDS: IBulkUploadCard[] = [
  {
    title: 'Órdenes',
    description:
      'Gestiona órdenes de forma masiva, ideal para migraciones o clientes sin acceso a la tienda.',
    icon: 'list2',
    firstButton: {
      text: 'Subir',
      icon: 'upload',
      route: '/bulk-upload/orders/upload'
    },
    secondButton: {
      text: 'Descargar',
      icon: 'download',
      route: '/bulk-upload/orders/download'
    }
  },
  {
    title: 'Catálogo de productos',
    description:
      'Mantén actualizado los precios y productos de los catálogos por países de manera rápida y masiva.',
    icon: 'layers',
    firstButton: {
      text: 'Subir',
      icon: 'upload',
      route: '/bulk-upload/catalog/upload'
    },
    secondButton: {
      text: 'Descargar',
      icon: 'download',
      route: '/bulk-upload/catalog/download'
    }
  }
];

export const HISTORY_HEADERS = ['Fecha', 'ID del cargue', 'Responsable', 'Estado del cargue', 'Plantilla'];
